<template>
    <section v-if="json" class="page-about">
        <div class="capper" data-aos="custom-fade-in">
            <div class="capper-padded">
                <div class="copy">
                    <div class="rte no-max-width">
                        <h1 v-if="json.title" v-html="formatFunkyTitle(json.funkyCopyTitle)"></h1>
                        <div class="under-title" v-if="json.body" v-html="json.body"></div>
                        <p>&nbsp;</p>
                        <p class="dot-ac" v-if="json.linkout">
                            <span class="dot"></span>
                            <Link
                                :href="json.linkout.url"
                                :target="json.linkout.target"
                                :label="json.linkout.label"
                                classes="Zlink-underline-leftright-dark"
                            />
                        </p>

                    </div>

                    <div class="expandables">
                        <div
                            v-for="(item, index) in json.positions"
                            :class="['expandable', (expandableSectionOpen === index) ? 'open' : 'closed']"
                            :key="`expandable${index}`"
                        >
                            <h3 @click="toggleSection(index)">
                                <span class="dot"></span>
                                <span class="title">{{item.title}}</span>
                                <span v-if="item.area" class="area">&nbsp;&mdash;&nbsp;{{item.area}}</span>
                            </h3>
                            <div ref="expandableContent" class="expanded" :data-index="index">
                                <div ref="expandableContentRte" class="rte no-max-width" v-html="item.body"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="json.featurePanel" class="capper">
            <FeaturedSlides v-if="json.featurePanel"  mode="basic" :bgContentArray="json.featurePanel"></FeaturedSlides>
        </div>
    </section>
</template>

<script>
import axios from 'axios'
import gh from '@/helpers/gh'
import FeaturedSlides from "@/components/blocks/FeaturedSlides.vue";
import Link from "@/components/pieces/Link.vue";

export default {
    name: "AboutPage",
    components: {Link, FeaturedSlides},
    data () {
        return {
            window: window,
            json: null,
            gh: gh,
        }
    },
    mounted () {
        let slug = this.$route.fullPath
        slug = gh.stripSlashesFrontAndBack(slug)
        axios.get((`${window.config.apiroot}${slug}/${window.config.craftApiPreviewToken}`))
            .then((res) => {
                this.json = res.data
            }).catch((e) => {
            console.error('Error', slug, e)
        })
    },
    beforeUnmount() {

    },
    methods: {
        formatFunkyTitle(text) {
            text = this.gh.removeTags(text)
            return text.replace(/\./g, "<span class='blue'>.</span>");
        }
    }
}
</script>